import { p as pako } from './pako.esm-ef1fc3f4.mjs';

class Zlib {
    constructor(level = 1) {
        if (level < -1 || level > 9) {
            throw new Error('Invalid zlib compression level, it should be between -1 and 9');
        }
        this.level = level;
    }
    static fromConfig({ level }) {
        return new Zlib(level);
    }
    encode(data) {
        const gzipped = pako.deflate(data, { level: this.level });
        return gzipped;
    }
    decode(data, out) {
        const uncompressed = pako.inflate(data);
        if (out !== undefined) {
            out.set(uncompressed);
            return out;
        }
        return uncompressed;
    }
}
Zlib.codecId = 'zlib';

export default Zlib;
